import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NormalizingTranslateService } from '@qwyk/core';

import { LanguagePickerComponent } from './components';

export class PortalsTranslationConfig {
    translationsDeployUrl: string;
    cacheKey?: string;
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule,
        DropdownModule,
        FontAwesomeModule,
        OverlayPanelModule,
        TranslateModule.forChild({ extend: true }),
    ],
    declarations: [LanguagePickerComponent],
    exports: [LanguagePickerComponent],
    providers: [
        { provide: TranslateService, useClass: NormalizingTranslateService },
    ],
})
export class PortalsTranslationModule {
    static forRoot(
        config: PortalsTranslationConfig
    ): ModuleWithProviders<PortalsTranslationModule> {
        return {
            ngModule: PortalsTranslationModule,
            providers: [
                { provide: PortalsTranslationConfig, useValue: config },
            ],
        };
    }
}
